import {
  ACTIVATE_CONFIG_ASYNC,
  DATA_REQUEST_ASYNC,
  FETCH_CONFIG_ASYNC,
  FETCH_LICENSED_DOMAINS_ASYNC,
  UPDATE_CONFIG_ASYNC,
  VALIDATE_CONNECTION_ASYNC,
} from './constants'

const initialState = {
  data: {},
  configLoaded: false,
  loader: false,
  error: null,
  errorType: null,
  validationResult: null,
  activationCompleted: false,
  licensedDomains: [],
  licensedDomainsLoader: false,
}

export default function emailEncryptionIntegrationReducer(state = initialState, action) {
  switch (action.type) {
    case DATA_REQUEST_ASYNC.INITIATE:
      return { ...state, loader: true, error: null, errorType: null }
    case VALIDATE_CONNECTION_ASYNC.INITIATE:
      return { ...state, loader: true, error: null, errorType: null, validationResult: null }
    case ACTIVATE_CONFIG_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
        errorType: null,
        activationCompleted: false,
      }
    case UPDATE_CONFIG_ASYNC.INITIATE:
      return { ...state, loader: true, error: null, errorType: null }

    case DATA_REQUEST_ASYNC.SUCCESS:
    case UPDATE_CONFIG_ASYNC.SUCCESS:
      return { ...state, data: action.payload.data, loader: false, error: null, errorType: null }

    case ACTIVATE_CONFIG_ASYNC.SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loader: false,
        error: null,
        errorType: null,
        activationCompleted: true,
      }

    case VALIDATE_CONNECTION_ASYNC.SUCCESS:
      return { ...state, loader: false, validationResult: action.payload?.data ?? action.payload }

    case VALIDATE_CONNECTION_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        error: action.error ?? action.payload,
        errorType: action.errorType ?? null,
      }

    case DATA_REQUEST_ASYNC.ERROR:
    case UPDATE_CONFIG_ASYNC.ERROR:
      return {
        ...state,
        error: action.error,
        errorType: action.errorType ?? null,
        loader: false,
      }

    case ACTIVATE_CONFIG_ASYNC.ERROR:
      return {
        ...state,
        error: action.error,
        errorType: action.errorType ?? null,
        loader: false,
        activationCompleted: false,
      }

    case DATA_REQUEST_ASYNC.CANCEL:
      return { ...state, loader: false }

    case FETCH_CONFIG_ASYNC.INITIATE:
    case FETCH_CONFIG_ASYNC.CANCEL:
      return { ...state, configLoaded: false }
    case FETCH_CONFIG_ASYNC.SUCCESS:
      return { ...state, data: action.payload, configLoaded: true }
    case FETCH_CONFIG_ASYNC.ERROR:
      return { ...state, error: action.error, errorType: action.errorType ?? null }

    case FETCH_LICENSED_DOMAINS_ASYNC.INITIATE:
      return { ...state, licensedDomainsLoader: true }
    case FETCH_LICENSED_DOMAINS_ASYNC.SUCCESS:
      return { ...state, licensedDomainsLoader: false, licensedDomains: action.payload.domains }
    case FETCH_LICENSED_DOMAINS_ASYNC.ERROR:
      return { ...state, licensedDomainsLoader: false }

    default:
      return state
  }
}
